module.exports = __webpack_public_path__ + "src/assets/individualImages/honeyOutlineIcon.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/individualImages/honeyOutlineIcon.png
// module id = ./src/assets/individualImages/honeyOutlineIcon.png
// module chunks = 0